import { ReactNode } from 'react';

import { Header } from './header/Header';
import { NavSidebar } from './nav/NavSidebar';
import { RouteErrorBoundary } from '@/components/error-boundary';

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="flex flex-col h-screen bg-sidebar">
      <Header />
      <div className="flex flex-1 min-h-0">
        <NavSidebar />
        <main className="flex-1 mb-4 mr-4 overflow-hidden border bg-background rounded-2xl border-border">
          <RouteErrorBoundary>{children}</RouteErrorBoundary>
        </main>
      </div>
    </div>
  );
}
